import React from "react";
import styles from '../styles/depositGiftBanner.module.scss'
import SpriteContainer from "@/wmCompoments/spriteContainer";
import { useNavigate } from "react-router";
import { useTranslation } from "react-i18next";


const DepositGiftBanner = () => {
    const navigate = useNavigate()
    const { t } = useTranslation('centralWallet')
    const lightItems = [{
        title: t('memberGrowth'),
        image: 'icon_growth',
        path: '/vip',
        show: true,
    }, 
    // {
    //     title: "高额返水",
    //     image: 'icon_growth',
    //     show: false,
    // }, 
    // {
    //     title: "新人首存",
    //     image: 'icon_growth',
    //     show: false,
    // },
    // {
    //     title: "豪礼盛宴",
    //     image: 'icon_growth',
    //     show: false,
    // }
    ]
    const items = lightItems.filter((item)=> {return item.show === true})

    return <div className={styles.depositGiftBanner}>
        <div className={styles.title}>{t('depositBonus')}</div>
        <div className={styles.content}>
            {items.map((v,index)=>{
                return <div key={index} className={styles.item} onClick={()=>{if(v.path){navigate(v.path)}}} >
                    <SpriteContainer className={styles.icon} name={v.image} module={'wallet'}  />
                    <div>{v.title}</div>
                </div>
            })}
        </div>
    </div>
}

export default DepositGiftBanner